import * as React from 'react'
import { ReactElement, useEffect, useState } from 'react'
import { SpinButton } from '@fluentui/react-components'
import { formatNumber, parseNumber } from '../../../../helpers/numberHelper'
import { SpinButtonProps } from '@fluentui/react-spinbutton'

type RateInputProps = Partial<Omit<SpinButtonProps, 'onChange' | 'onFocus' | 'onBlur' | 'value'>> & {
    value: string
    displayFormat?: string
    onChange: (displayValue: string) => void
}

export default function FactorInput(props: RateInputProps): ReactElement {
    const [currentValue, setCurrentValue] = useState<number>(parseNumber(formatNumber(0, props.displayFormat ?? '0.0', 'en'), 'en'))
    const [displayValue, setDisplayValue] = useState<string>()

    useEffect(() => {
        if (props.value === displayValue) {
            return
        }

        if (props.value !== undefined) {
            setCurrentValue(parseNumber(formatNumber(props.value, props.displayFormat ?? '0.0', 'en'), 'en'))
            setDisplayValue(props.value)
        } else {
            setCurrentValue(undefined)
            setDisplayValue(undefined)
        }
    }, [props.value])

    return (
        <SpinButton
            precision={1}
            min={0}
            max={100}
            step={0.1}
            {...props}
            value={currentValue}
            displayValue={displayValue}
            onChange={(_, data) => {
                if (data.value && data.value !== currentValue) {
                    setCurrentValue(data.value)
                    setDisplayValue(formatNumber(data.value, props.displayFormat ?? '0.0', 'en'))
                    props.onChange(formatNumber(currentValue, props.displayFormat ?? '0.0', 'en'))
                } else if (data.displayValue && data.displayValue !== displayValue) {
                    setCurrentValue(parseNumber(formatNumber(data.displayValue, props.displayFormat ?? '0.0', 'en'), 'en'))
                    setDisplayValue(data.displayValue)
                    props.onChange(data.displayValue)
                }
            }}
        />
    )
}
